import React, { useContext, useState, useEffect, useCallback } from "react";
import { MapContext } from "./Map";
import "./Zoom.css";

const Zoom = () => {
  const map = useContext(MapContext);
  const [zoom, setZoom] = useState(map.getZoom());

  const onZoom = useCallback(() => setZoom(map.getZoom()), [map]);

  useEffect(() => {
    map.on("zoom", onZoom);
    return () => map.off("zoom", onZoom);
  }, [map, onZoom]);

  return <div className="Zoom">Zoom: {Math.round(zoom * 10) / 10}</div>;
};

export default Zoom;
